import MealList from "../components/Meals/MealList";

export default function Meals(){
    return <MealList/>
}